export const showProfileAlert = (title: string, body: string) => window.alert(`${title}\n${body}`);
